import { subscribe } from '@wh/message-bus';
import { getValueFromContent } from '../../utils';

export const logoPlugin = {
  beforeRender({ header, content, params }) {
    if (process.env.RUNTIME === 'browser') {
      subscribe('wh.common.event.ui.header.logo.requested', (_topic, data) => {
        const {
          link: { url, target = '_self' },
        } = data;

        if (typeof url === 'string') {
          const linkWindow = window.open(url, target);
          linkWindow.focus();
        }
      });
    }

    header.logo = {
      type: '@sitebase/logo',
      data: {
        id: 'hrs-logo',
        link: {
          id: 'hrs-logo',
          url: getValueFromContent(params.href, content, '//'),
        },
      },
    };
  },
};
